import { colors } from 'shared/styles/colors'
import styled, { css } from 'styled-components'

interface IContainerProps {
  open: boolean
}

export const Container = styled.div<IContainerProps>`
  display: none;
  ${props =>
    props.open &&
    css`
      display: block;
    `}
`

export const Backdrop = styled.div`
  height: calc(100% + 101px);
  z-index: 998;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: black;
  opacity: 0.1;
`

interface ISideBarProps {
  width?: string
}

export const SideBar = styled.div<ISideBarProps>`
  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;
  background: ${colors.white};
  width: ${props => props.width ?? '43%'};
  height: calc(100% + 30px);
  box-shadow: -2px 8px 11px 1px rgba(0, 0, 0, 0.31);
  transition: width 0.35s;
  overflow: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(36, 169, 93, 1);
    border-radius: 70px;
  }
`
